export const STAGGERED_TOOLTIP_TITLE_DEFAULT = 'Staggered Fitment'
export const STAGGERED_TOOLTIP_DESCRIPTION_DEFAULT = `Staggered fitment is when the back wheels
of a vehicle are a different size than the wheels on the front. If your vehicle has a
staggered fitment, you can enter each size separately.`
